import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { CampaignSelector } from './CampaignSelector';
const formatCurrency = (value: number) => value.toLocaleString('en-US');
export function EdgePricing() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = isPartial ? 3500 : 3500 + 1000 * (campaignMode - 1);
  const systemFee = 1500;
  const campaignFee = isPartial ? 750 : 1000 * campaigns;
  const monthlyTotal = systemFee + campaignFee;
  return <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-61" data-mp="30as2v670xgfl">
      <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="slate" data-id="element-62" data-mp="356gwyu09y54i" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-63" data-mp="3a51wssbm6msf">
        <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-64" data-mp="kh18i5oj2si1">
          <div className="mb-4" data-id="element-65" data-mp="pfmd0hatbyca">
            <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-66" data-mp="piqlhqvb9g8r">
              Build and Implementation (One-Time)
            </div>
            <div className="text-3xl font-bold text-white" data-id="element-67" data-mp="mddxfat7z9xg">
              ${formatCurrency(buildFee)}
            </div>
            <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-68" data-mp="hbojnnem4i5o">
              {['Company and opportunity profiling', 'Custom ATS, workflows, and job board integrations', 'Landing page and candidate application flow', 'Campaign messaging and ad creative', 'Pre-launch system setup and stress test', 'Access to HIRE’s LMS best-practices library', 'Interview process training', 'Three Sales School tickets'].map(point => <li key={point} className="flex items-start" data-id="element-69" data-mp="3ksn8sbwwuwr0">
                  <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-70" data-mp="3fv54wzxr37pv" />
                  <span className="text-slate-400 text-sm leading-snug" data-id="element-71" data-mp="3679duc3xhvcs">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-600 p-6 rounded-xl relative" data-id="element-72" data-mp="2x6urd9f8aa7p">
          <div className="absolute top-0 left-0 w-full h-1 bg-slate-500 rounded-t-xl" data-id="element-73" data-mp="3186l9r54xhlp" />
          <div className="mb-4" data-id="element-74" data-mp="319zqd203ntrl">
            <div className="text-xs text-slate-400 uppercase tracking-widest mb-2" data-id="element-75" data-mp="3oxhbieouztll">
              Total Monthly
            </div>
            <div className="text-4xl font-bold text-white mb-1" data-id="element-76" data-mp="3twc428cmowiw">
              ${formatCurrency(monthlyTotal)}
            </div>
            <div className="text-sm text-slate-500 mb-6" data-id="element-77" data-mp="3g3mha1p9znkq">/ month</div>

            <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-78" data-mp="3k5hg8zjqhovc">
              <div className="flex justify-between text-sm" data-id="element-79" data-mp="bqz6mte5a19m">
                <span className="text-slate-400" data-id="element-80" data-mp="ghxldojhirar">System Fee</span>
                <span className="text-white font-medium" data-id="element-81" data-mp="gjijtp8x6udw">
                  ${formatCurrency(systemFee)}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-82" data-mp="1w9jb3w9qpaao">
                <span className="text-slate-400" data-id="element-83" data-mp="1w76ylymr3s50">
                  {isPartial ? 'Partial Campaign' : campaigns === 1 ? 'Full Campaign' : `Full Campaigns (×${campaigns})`}
                </span>
                <span className="text-white font-medium" data-id="element-84" data-mp="1ia0ikbtew7jh">
                  ${formatCurrency(campaignFee)}
                </span>
              </div>
            </div>

            <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-85" data-mp="1s87ntxec915n">
              {['Active job board management and campaign optimization', 'Applicant screening and pre-qualification', 'Candidate handoff to your internal team', 'Multi-market coordination and reporting', 'Ongoing system support and performance visibility'].map(point => <li key={point} className="flex items-start" data-id="element-86" data-mp="188ps46p6tai9">
                  <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-87" data-mp="1d6r82irbgtpi" />
                  <span className="text-slate-400 text-sm leading-snug" data-id="element-88" data-mp="1h71okpcqj2im">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-89" data-mp="1r4fvnycrqey9">
          <div className="mb-4" data-id="element-90" data-mp="1w425dxte1d2b">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-91" data-mp="1w30vhwo3ywm6">
              Sales School Tickets
            </div>
            <div className="flex items-baseline mb-2" data-id="element-92" data-mp="20xoddcolwsrs">
              <span className="text-3xl font-bold text-white" data-id="element-93" data-mp="24vm2kfidnev6">$250</span>
              <span className="text-slate-400 ml-2 text-sm" data-id="element-94" data-mp="29wruib47qy3n">per ticket</span>
            </div>
            <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-95" data-mp="2eujyw4m1ocoq">
              Sales School tickets are purchased separately based on the number
              of attendees.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-96" data-mp="2k29xw8fwau62">
        <p className="text-[#7FE0C3] text-center font-medium" data-id="element-97" data-mp="2f2nhjq4rsxt1">
          Ad spend is paid directly to the job platforms and is separate from
          HIRE&apos;s fees.
        </p>
      </div>
    </section>;
}